import { render } from "./Xiang.vue?vue&type=template&id=c40e565e&scoped=true&ts=true"
import script from "./Xiang.vue?vue&type=script&lang=ts"
export * from "./Xiang.vue?vue&type=script&lang=ts"

import "./Xiang.vue?vue&type=style&index=0&id=c40e565e&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c40e565e"]])

export default __exports__